import { useLocaleStore } from "@/store";
export function createLocaleSpecificSanityId(routeParamsId) {

  const localeStore = useLocaleStore();
  
  const hasLocale = localeStore.getSanityLocaleId && !routeParamsId.includes("__i18n");

  const localeSpecificSanityId = hasLocale
    ? routeParamsId + localeStore.getSanityLocaleId
    : routeParamsId;
  return localeSpecificSanityId;
}
